<template>
  <div v-if="errors.length" class="errors" :class="{visible: errors.length}" @click="popError">
    <div class="message shadow">
      {{ errors[0] }}
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'errors',
    data () {
      return {}
    },
    computed: {
      ...mapState('errors', ['errors'])
    },
    methods: {
      ...mapActions('errors', ['popError'])
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .errors {
    color: rgba(245, 245, 245, .8);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    padding: 1rem;
    opacity: 0;
    transition: all 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .message {
      cursor: pointer;
      background-color: rgba(244, 67, 54, 0.9);
      padding: 1rem;
    }
    &.visible {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// Errors.vue?6f199bf3